<template>
  <material-card
    :title="`${ $t('Timezone') }`"
    color="dover-blue">
    <v-form
      v-if="systemSettings !== undefined"
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout wrap>
          <v-flex
            xs8
            md8>
            <br >
            <v-date-picker
              v-model="datePicker"
              full-width
              show-current
              type="date"
              dark />
          </v-flex>
          <v-flex
            xs4
            md4>
            <v-time-picker
              v-model="timePicker"
              :allowed-minutes="allowedStep"
              dark
              class="mt-3"
              format="24hr"
            />
          </v-flex>
          <v-flex
            xs4
            md4
            text-xs-center>
            <v-text-field
              v-model="dateTime"
              :label="`${ $t('Date/time to set') }`"
              class="dover-input"
              disabled
            />
          </v-flex>
          <v-flex
            xs4
            md4>
            <v-select
              v-model="appTimezone"
              :items="appTimezones"
              :label="`${ $t('Timezone') }`"
              item-text="desc"
              item-value="code"
              class="dover-input"
              chips
            >
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item"
                  class="v-chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                >{{ data.item }}</v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs4
            md4>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="save"
            >{{ $t('Save') }}</v-btn>
            {{ $t('Console will reboot on save').toUpperCase() }}
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
export default {
  data: () => ({
    isValidationOk: false,
    datePicker: new Date().toISOString().substr(0, 10),
    timePicker: new Date().toISOString().substr(11, 5),
    systemSettings: undefined,
    appTimezone: '',
    timezones: [],
    appTimezones: []
  }),
  computed: {
    dateTime () {
      return this.getSelectedDate()
    }
  },
  mounted () {
    // Etc/
    for (let index = 12; index >= 1; index--) {
      this.timezones.push({ app: 'GMT+' + index, console: 'Etc/GMT' + (-1) * index })
      // this.appTimezones.push('GMT+' + index)
    }
    this.timezones.push({ app: 'GMT-0', console: 'Etc/GMT-0' })
    // this.appTimezones.push('GMT-0')
    for (let index = -1; index >= -12; index--) {
      this.timezones.push({ app: 'GMT' + index, console: 'Etc/GMT+' + (-1) * index })
      // this.appTimezones.push('GMT' + index)
    }
    this.appTimezones = this.timezones.map(a => a.app)

    this.Maglink.GetSettings('SystemSettings')
      .then(
        response =>
          (this.systemSettings = { ...this.systemSettings, ...response.data })
      )
      .catch(error => this.snack('error', error.message))

    this.Maglink.GetTimezone()
      .then(response => {
        let tz = response.data.current
        this.appTimezone = this.timezones.filter(item => item.console === tz).map(item => item.app)
        let consoleDateTime = response.data.time.split(' ')
        this.datePicker = consoleDateTime[0]
        this.timePicker = consoleDateTime[1]
      })
      .catch(error => this.snack('error', error.message))
  },
  methods: {
    allowedHours: v => v % 2,
    allowedMinutes: v => v >= 10 && v <= 50,
    allowedStep: m => m % 1 === 0,
    dateFunctionEvents (date) {
      const [, , day] = date.split('-')
      if ([12, 17, 28].includes(parseInt(day, 10))) return true
      if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
      return false
    },
    monthFunctionEvents (date) {
      const month = parseInt(date.split('-')[1], 10)
      if ([1, 3, 7].includes(month)) return true
      if ([2, 5, 12].includes(month)) {
        return ['error', 'purple', 'rgba(0, 128, 0, 0.5)']
      }
      return false
    },
    getSelectedDate () {
      let dateStamp = this.datePicker

      if (this.systemSettings !== undefined) {
        let newDateSplit = this.datePicker.split('-')
        let newDate = new Date(
          newDateSplit[0],
          newDateSplit[1] - 1,
          newDateSplit[2]
        )
        dateStamp = this.Maglink.GetCustomDate(
          newDate,
          this.systemSettings.dateFormat
        )
      }
      return dateStamp + ' - ' + this.timePicker.substr(0, 5)
    },
    getDateParam () {
      let dateParam = this.datePicker.replace(/-/g, '').substr(2)
      dateParam += this.timePicker.replace(/:/g, '').substr(0, 4)
      return dateParam
    },
    save (event) {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true
        let tm = this.timezones.filter(item => item.app === this.appTimezone).map(item => item.console)

        this.Maglink.SetTimezone(tm, this.getDateParam())
          .then(response => this.snack('success', response.data['done']))
          .catch(error => this.snack('error', error.message))
      } else {
        this.isValidationOk = false
      }
    },
    snack (color, message) {
      message = this.$t('Timezone') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
